import React from 'react'
import Table from '@material-ui/core/Table'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import axios from 'axios'
import Grid from '@material-ui/core/Grid'
import Header from './Header'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import {Link} from 'react-router-dom'

import TableContainer from '@material-ui/core/TableContainer'
class ViewRmaform extends React.Component
{
   constructor(props)
   {
       super(props)
       this.state={
           records:[]
       }
   } 
componentDidMount()
{
axios.post('https://www.thespiritofdubai.com/rmaform/php/getrecords.php').then(res=>{
const records=res.data
this.setState({records})


})
} 
handleChange(val)
{
axios.post('https://www.thespiritofdubai.com/rmaform/php/getrecords.php?q='+val).then(res=>{
const records=res.data
this.setState({records})   
})
}
render()
{
 
const records =    this.state.records || []
return(
    <>
   
    <TableContainer>
        <Table style={{width:"90%",margin:"auto"}}>
            <Header />
            <tbody>
        <TableRow>
            <TableCell align="center" style={{height:"20px"}}><h6><u>VIEW RETURN MERCHANDISE AUTHORIZATION</u></h6></TableCell>
        </TableRow>
        <TableRow><TableCell>
        <TextField
          id="outlined-number"
          label="Search"
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined" onChange={e=>this.handleChange(e.target.value)}
        />
          </TableCell></TableRow>
        <TableRow>
        <TableCell style={{width:"100%"}}>
        <Grid container direction="row" justify='center' spacing={3}>    
        {records.map(res=>
           
            
           <Grid item xs={4}>  
            <Card >
            <CardHeader title={res.rmaid}><br />
            </CardHeader> 
          
            
            <CardContent>
            <strong>{res.customername}</strong><br /> 
            {res.productname}  <br />    
            {res.complaint}  <br />
            {res.location}   <br />
            {res.invoiceno}  <br />
           
           <Link to={`/edit/${res.id}`}>QC Reply</Link> <br />
           <Link to={`/complete/${res.id}`}>Complete</Link>
            </CardContent>
            
           
           
           
           
            </Card></Grid> 
        )}
         </Grid>
        </TableCell>
        </TableRow>
        </tbody>
        </Table>
    </TableContainer>

   
    </>
)

   

}

}
export default ViewRmaform